import { useCallback, useEffect, useState } from 'react'
import { ButtonCloseModal, ModalFullCentered } from '../../../../../../baseComponents/Modal'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import twinFetchPost from '../../../../../../utils/globals/data'
import { TwinDictionary } from '../../../../../../utils/globals/dictionary'
import LoadingSpinner from '../../../../../../baseComponents/LoaderDecider/LoadingSpinner'
import './modalPreviewPdfOrder.sass'

type ModalPreviewPdfOrderProps = ModalPreviewPdfOrderLogicProps & ModalEditComponentProps & {}

const ModalPreviewPdfOrder: React.FC<ModalPreviewPdfOrderProps> = ({ setOpened, Order, PdfTemplateId, urlGetPdf }) => {
    const { pdfCode } = useModalPreviewPdfOrderLogic({ Order, PdfTemplateId, urlGetPdf })
    return (
        <ModalFullCentered className='flex flex-col modal_preview_pdf' opened={true} setOpened={setOpened}>
            <ButtonCloseModal setOpened={setOpened} />
            {pdfCode ? <object data={pdfCode} type="application/pdf" width="100%" height="100%" aria-label='pdf' className='preview_pdf'></object> : <LoadingSpinner />}
        </ModalFullCentered>
    )
}

interface ModalPreviewPdfOrderLogicProps {
    Order: TwinDictionary
    PdfTemplateId: number
    urlGetPdf: string
}

const useModalPreviewPdfOrderLogic = ({ Order, PdfTemplateId, urlGetPdf }: ModalPreviewPdfOrderLogicProps) => {
    const [pdfCode, setPdfCode] = useState<string | null>(null)
    const getPdfTemplate = useCallback(async () => {
        const result = await twinFetchPost(urlGetPdf, { id: Order.id, PdfTemplateId})
        if (result) {
            const pdf = await result.blob()
            const fileURL = URL.createObjectURL(pdf)
            setPdfCode(fileURL)
        }
    }, [Order, setPdfCode, PdfTemplateId, urlGetPdf])

    useEffect(() => {
        getPdfTemplate()
    }, [getPdfTemplate])
    return { pdfCode }
}

export default ModalPreviewPdfOrder